import React from "react";

import "./blockchainproduct.scss";
import ProductInfo from "./productinfo";
import KeyComponent from "./keycomponent";
import InfoAccordion from "./infoAccordion";
import Footer from "../../components/footer";
import { IMAGES } from "../../common/constants";
import "../strain/recentBatches/recentBatch.scss";
import useBlockChainCoADetailsHelper from "./helper";
import ModuleHeader from "../../components/header/moduleHeader";
import "../scan-product/productDetailsTable/productDetailsTable.scss";
import { appendImageUrl, FormatDate, isUserLoggedIn } from "../../common/utils";

const BlockChainCoADetails = () => {
  const { productChainDetails } = useBlockChainCoADetailsHelper();

  return (
    <div className="blockChainCOAProductWrapper">
      <ModuleHeader pageTitle="COA DETAILS" isFilterVisible={false} />

      <figure className="productImg">
        <img
          src={
            productChainDetails?.sampleImage
              ? appendImageUrl(productChainDetails?.sampleImage, true)
              : ""
          }
          alt="Blockchain Product"
        />
      </figure>

      <div className="pageInnerWrapper">
        <ProductInfo productChainDetails={productChainDetails} />
        <InfoAccordion productChainDetails={productChainDetails} />
        <KeyComponent productChainDetails={productChainDetails} />
      </div>

      <div className="recentBatchesTableWrapper">
        <div className="topHead">
          <h4 className="title">Recent Batches</h4>
        </div>
        <div className="tableWrapper">
          <table className="recentBatchTable">
            <thead>
              <tr>
                <th>Batch Id</th>
                <th>Product type</th>
                <th>Added Date</th>
              </tr>
            </thead>
            <tbody>
              {productChainDetails?.primaryInfo?.batchId ? (
                <tr key={productChainDetails?.primaryInfo?.batchIndexId}>
                  <td>{productChainDetails?.primaryInfo?.batchId || "-"}</td>
                  <td>
                    {productChainDetails?.primaryInfo?.productType || "-"}
                  </td>
                  <td>
                    {productChainDetails?.primaryInfo?.productTokenizedAt
                      ? FormatDate(
                          productChainDetails?.primaryInfo?.productTokenizedAt,
                        )
                      : "-"}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={3}>
                    <div className="Nodata">
                      <img
                        src={IMAGES.Nodata}
                        alt="No data"
                        className="noDataImg"
                      />
                      <span className="text">No recent batches available.</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {productChainDetails?.coaPdfIpfsHash && (
        <div>
          <a
            href={appendImageUrl(productChainDetails?.coaPdfIpfsHash, true)}
            target="_blank"
            rel="noopener noreferrer"
            className="redirectionWrapper"
          >
            <iframe
              src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                appendImageUrl(productChainDetails?.coaPdfIpfsHash, true),
              )}&embedded=true`}
              style={{
                width: "95%",
                height: "400px",
                border: "none",
                margin: "0 auto",
              }}
              title="pdf-preview"
            />
            <p className="file-heading">Certificate of Analysis (CoA) PDF</p>
          </a>
        </div>
      )}

      {!isUserLoggedIn && <Footer />}
    </div>
  );
};

export default BlockChainCoADetails;
